import { Wrapper } from "./styled";
import dynamic from "next/dynamic";
const Lottie = dynamic(() => import("lottie-react"), { ssr: false });
import { Text } from "../..";
import logoAnimationData from "../lotties/logo.json";

const LoggedOutOverlay: React.FC = () => {
  return (
    <Wrapper>
      <Lottie
        animationData={logoAnimationData}
        style={{ width: 80 }}
        loop={true}
        autoPlay={true}
      />
      <Text alignText="center" color="white" size="12px">
        Unloading...
      </Text>
    </Wrapper>
  );
};

export default LoggedOutOverlay;
